// 展示頁面翻譯

export const showcase = {
    title: 'Catoo 作品展示',
    subtitle: '探索各種圖像處理效果，體驗專業AI技術的強大力量。',
    loadError: '載入展示圖片失敗，請稍後重試',
    featured: '精選',
    downloadStarted: '下載已開始',
    generatedImage: '生成的圖片',
    noTitle: '無標題',
    noMoreImages: '沒有更多圖片了',
    noImagesFound: '未找到展示圖片',
    noImagesDescription: '目前沒有可用的展示圖片。請稍後查看新內容！'
  };
